import React from 'react';
import PropTypes from 'prop-types';
import Link from '@ux/link';

const LinkBuilder = (props) => {
  const { title, eid, href, classNames, urlArgs } = props;

  if (!title || !href) {
    return null;
  }

  return (
    <li className={ classNames }>
      <Link urlArgs={ urlArgs }
        href={ href }
        data-eid={ eid }>
        <span>{ title }</span>
      </Link>
    </li>
  );
};

LinkBuilder.propTypes = {
  classNames: PropTypes.string,
  eid: PropTypes.string,
  href: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.string,
  urlArgs: PropTypes.object
};

export default LinkBuilder;
